export const menuItems = [
    {
      id: 3,
      label: "menuitems.dashboards.text",
      link: '/',
      icon: "bx-home-circle",
      roles: ["ROLE_AGENT","ROLE_MANAGER"], // Roles that can see this item
    },
    {
      id: 4,
      label: "menuitems.catalog.text",
      link: '/catalogs',
      icon: "bx-layout",
      roles: ["ROLE_MANAGER"], // Roles that can see this item
    },
    {
      id: 5,
      label: "menuitems.folders.text",
      link: '/folders',
      icon: "bx-file",
      roles: ["ROLE_AGENT","ROLE_MANAGER"], // Roles that can see this item
    },
    {
      id: 6,
      label: "menuitems.proposals.text",
      link: '/proposals',
      icon: "bx-calendar-check",
      roles: ["ROLE_AGENT","ROLE_MANAGER"], // Roles that can see this item
    },
    {
      id: 7,
      label: "menuitems.settings.text",
      icon: "bx bx-cog",
      roles: ["ROLE_ADMIN"], // Roles that can see this item
      subItems: [
        {
          id: 1,
          label: "menuitems.settings.list.users",
          link: "/users",
          parentId: 7,
          roles: ["ROLE_ADMIN"], // Roles that can see this item
        },
        {
          id: 2,
          label: "menuitems.settings.list.rgpd",
          link: "/gestion",
          parentId: 7,
          roles: ["ROLE_ADMIN"], // Roles that can see this item
        },
      ]
    },
  ];
  